import React, { useState } from "react";
import "../CSS/footer.css";
import logo from "../../assets/footer/logo1.png";
import { Link } from "react-router-dom";
import insta from "../../assets/Instagram.png";
import linkedin from "../../assets/LinkedIn.png";
import youtube from "../../assets/YouTube.png";
import facebook from "../../assets/Facebook.png";
import Twitter from "../../assets/Twitter Squared.png";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import { getBaseUrl } from "../../service/apiUrl";
const Footer = () => {
  const { t } = useTranslation();
  const [EmailSend, setEmailSend] = useState("");
  // const { data: ThemeSetting } = useSelector((state) => state.ThemeSetting); // Logic kept

  const submit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("email", EmailSend);
      const res = await axios.post(
        `${getBaseUrl()}/api/v1/addnewsletter`,
        formData
      );
      toast(res.data.message);
    } catch (error) {
      toast(error.response.data.message);
    }
    setEmailSend("");
  };

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Demo Instagram Images array
  const instaImages = [
    "https://picsum.photos/100/100?random=1",
    "https://picsum.photos/100/100?random=2",
    "https://picsum.photos/100/100?random=3",
    "https://picsum.photos/100/100?random=4",
    "https://picsum.photos/100/100?random=5",
    "https://picsum.photos/100/100?random=6",
    "https://picsum.photos/100/100?random=7",
    "https://picsum.photos/100/100?random=8",
  ];

  return (


    <div className="new-footer-main">
      <div className="new-footer-container">
        <div className="new-footer-grid">

          {/* Section 1: Logo & Socials */}
          <div className="new-footer-section">
            <div className="new-footer-logo">
              <img src={logo} alt="Saddle Battle" />
            </div>
            <div className="new-footer-socials">
              <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" className="new-footer-social-icon"><img src={facebook} alt="fb" /></a>
              <a href="https://www.youtube.com/" target="_blank" rel="noreferrer" className="new-footer-social-icon"><img src={youtube} alt="yt" /></a>
              <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" className="new-footer-social-icon"><img src={insta} alt="ig" /></a>
              <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer" className="new-footer-social-icon"><img src={linkedin} alt="in" /></a>
            </div>
            <div className="new-footer-info">
              {/* <p>{t("Location")}</p> */}
              <p><a href="mailto:info@saddlesbattles.com" style={{ color: 'white', textDecoration: 'none' }}>info@saddlesbattles.com</a></p>
            </div>

            {/* Keeping your Newsletter logic inside without breaking UI */}
            <div className="new-footer-newsletter" style={{ marginTop: '20px' }}>
              <form onSubmit={submit} style={{ display: 'flex', gap: '5px' }}>


                <input
                  type="email"
                  className="new-footer-input"
                  placeholder={t("Subscribe")}
                  onChange={(e) => setEmailSend(e.target.value)}
                  value={EmailSend}
                />
                <button type="submit" style={{ fontSize: '12px', background: '#1b73e8', color: 'white', border: 'none', borderRadius: '4px', padding: '0 10px' }}>{t("Go")}</button>
              </form>
            </div>
          </div>

          {/* Section 2: Quick Links (2 Columns) */}
          <div className="new-footer-section new-footer-links-block">
            <h5 className="new-footer-title">{t("Quicklinks")}</h5>
            <div className="new-footer-links-columns">
              <ul className="new-footer-links-list">
                {/* <li><Link to="/about" onClick={handleScrollToTop}>{t("about")}</Link></li> */}
                {/* <li><Link to="/racecards" onClick={handleScrollToTop}>{t("race_card")}</Link></li> */}
                <li><Link to="/result" onClick={handleScrollToTop}>{t("result")}</Link></li>
              </ul>

              <ul className="new-footer-links-list">
                <li><a href="https://silk.saddlebattles.com/" target="_blank" rel="noreferrer">{t("Owner Silk")}</a></li>
                {/* <li><Link to="/racecourses" onClick={handleScrollToTop}>{t("race_course")}</Link></li> */}
                <li><Link to="/competition" onClick={handleScrollToTop}>{t("competition")}</Link></li>
              </ul>
            </div>
          </div>

          {/* Section 4: Instagram Grid */}
          <div className="new-footer-section">
            <h5 className="new-footer-title">{t("Instagram")}</h5>
            <div className="new-insta-grid">
              {instaImages.map((src, index) => (
                <img key={index} src={src} alt="insta" className="new-insta-img" />
              ))}
            </div>
          </div>

        </div>
      </div>


    </div>
  );
};

export default Footer;
